<mat-form-field>
  <mat-label>Report Type</mat-label>
  <mat-select
    name="apps"
    [(ngModel)]="reportType"
    (selectionChange)="reportTypeChange($event)"
  >
    @for (type of reportTypes; track type.value) {
      <mat-option [value]="type.value">{{ type.display }}</mat-option>
    }
  </mat-select>
</mat-form-field>
@if (reportType === 'assistant') {
  <mat-form-field>
    <mat-label>Users</mat-label>
    <mat-chip-grid #userList aria-label="User selection">
      @for (user of users; track user) {
        <mat-chip-row
          [removable]="removable"
          (removed)="removeItem(user, users)"
        >
          {{ user.name }}: {{ user.id }}
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-row>
      }
      <input
        #userInput
        placeholder="Search For Users..."
        [formControl]="userCtrl"
        [matAutocomplete]="autoUser"
        [matChipInputFor]="userList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addItem($event, users, userCtrl)"
      />
    </mat-chip-grid>
    <mat-autocomplete
      #autoUser="matAutocomplete"
      (optionSelected)="selectedUser($event)"
    >
      @for (user of filteredUsers; track $index) {
        <mat-option [value]="user"> {{ user.name }}: {{ user.id }} </mat-option>
      }
    </mat-autocomplete>
    <mat-hint>Unit ID will override this</mat-hint>
  </mat-form-field>
}
<mat-form-field>
  <mat-label>Unit</mat-label>
  <input
    matInput
    placeholder="Search For a Unit"
    name="usageUnitsControl"
    [matAutocomplete]="usageAuto"
    [formControl]="usageUnitsControl"
    (blur)="checkSelection()"
  />
  <mat-autocomplete
    #usageAuto="matAutocomplete"
    (optionSelected)="autoCompleteUnitChanged($event)"
  >
    @for (unit of filteredUnits; track unit.id) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (usageUnitsControl.value) {
    <button
      matSuffix
      mat-icon-button
      aria-label="Clear"
      color="warn"
      type="button"
      matTooltip="Clear Filter"
      (click)="clearUnitField($event)"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
<mat-form-field>
  <mat-label>Start Date</mat-label>
  <input
    matInput
    placeholder="Start Date"
    [matDatepicker]="startPicker"
    [(ngModel)]="usage.start"
  />
  <mat-datepicker-toggle matSuffix [for]="startPicker" />
  <mat-datepicker #startPicker />
</mat-form-field>
<mat-form-field>
  <mat-label>End Date</mat-label>
  <input
    matInput
    placeholder="End Date"
    [matDatepicker]="endPicker"
    [(ngModel)]="usage.end"
  />
  <mat-datepicker-toggle matSuffix [for]="endPicker" />
  <mat-datepicker #endPicker />
</mat-form-field>
<button
  type="button"
  mat-raised-button
  color="accent"
  class="mx-auto"
  [disabled]="
    !usage.start ||
    !usage.end ||
    !reportType ||
    (!usageUnitsControl.value && !users.length)
  "
  (click)="getUsage()"
>
  Get Report
</button>
<button
  type="button"
  mat-button
  color="primary"
  class="grid-button pull-right"
  [disabled]="!usageGridData.data.length || fileLoading"
  (click)="exportToExcel()"
>
  @if (fileLoading) {
    <ng-container>
      <mat-spinner class="me-1" diameter="20" /> File Loading...
    </ng-container>
  } @else {
    <ng-container>
      <mat-icon class="me-1">cloud_download</mat-icon> Download Excel File
    </ng-container>
  }
</button>

@if (noResults) {
  <div class="row mt-3 mb-0 mx-0">
    <div class="col-12 p-0">
      <p class="mb-0 grid-info"> No results </p>
    </div>
  </div>
} @else if (usageGridData.data.length <= 0 && !loading) {
  <div class="row mt-3 mb-0 mx-0">
    <div class="col-12 p-0">
      <p class="mb-0 grid-warning">
        Define filter criteria to generate report
      </p>
    </div>
  </div>
} @else {
  <kendo-grid
    #unitUsageGrid="kendoGrid"
    class="col-12 mt-3 usage-grid"
    [hidden]="!usageGridData.data"
    [data]="usageGridData"
    [skip]="skip * 1"
    [pageSize]="take"
    [columnMenu]="{ columnChooser: false }"
    [height]="600"
    [scrollable]="true"
    [pageable]="true"
    (dataStateChange)="dataStateChange($event)"
  >
    @for (col of usageGridData.headers; track col) {
      @if (col.DataField === 'policyId') {
        <kendo-grid-column width="70" [field]="col.DataField" [title]="''">
          <ng-template let-dataItem kendoGridCellTemplate>
            <button
              type="button"
              matIconButton
              color="primary"
              matTooltip="View Policy"
              [matTooltipShowDelay]="1000"
              (click)="viewPolicy(dataItem[col.DataField])"
            >
              <mat-icon>preview</mat-icon>
            </button>
          </ng-template>
        </kendo-grid-column>
      } @else {
        <kendo-grid-column [field]="col.DataField" [title]="col.Label">
          @if (col.Type === 'integer') {
            <ng-template let-dataItem kendoGridCellTemplate>
              {{ dataItem[col.DataField] | number: '1.0-0' }}
            </ng-template>
          } @else if (col.Type === 'decimal') {
            <ng-template let-dataItem kendoGridCellTemplate>
              {{ dataItem[col.DataField] | number: '1.1-2' }}
            </ng-template>
          } @else if (
            col.Type === 'date' || dateFormatted.includes(col.DataField)
          ) {
            <ng-template let-dataItem kendoGridCellTemplate>
              {{ dataItem[col.DataField] | localTime: 'shortDateTime' }}
            </ng-template>
          } @else {
            <ng-template let-dataItem kendoGridCellTemplate>
              <span [matTooltip]="dataItem[col.DataField]">{{
                dataItem[col.DataField]
              }}</span>
            </ng-template>
          }
        </kendo-grid-column>
      }
    }

    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <kendo-pager-prev-buttons />
      <kendo-pager-numeric-buttons [buttonCount]="5" />
      <kendo-pager-next-buttons />
      <kendo-pager-input />
      <kendo-pager-info />
      <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
    </ng-template>

    <kendo-grid-excel fileName="RightBridge-UnitUsageReport.xlsx" />
  </kendo-grid>
}

<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
